function setLocation(locationId = null) {
    if (locationId === null) {
        if(document.body.dataset.currentLocationId) {
            locationId = document.body.dataset.currentLocationId;
            fetch('/cart/update.js', {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "attributes": {
                    "_location_id": parseInt(locationId)
                    }
                })
            }).then(response => {
                if (response.ok) {
                    localStorage.setItem('_location_id', parseInt(locationId));
                    updateCartPerInventory();
                }
            });
        } else {
            // if no location
            if(localStorage.getItem('_location_id') === null) {
                if(document.querySelectorAll('location-picker').length) {
                    document.querySelectorAll('location-picker')[0].click();
                }
            }
        }
    } else {
        document.body.dataset.currentLocationId = locationId;
        fetch('/cart/update.js', {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "attributes": {
                "_location_id": parseInt(locationId)
                }
            })
        }).then(response => {
            if (response.ok) {
                localStorage.setItem('_location_id', parseInt(locationId));
                updateCartPerInventory();
            }
        });
        updateCartPerInventory();
    }
}


async function updateCartPerInventory() {
    // Step 1: Fetch inventory info
    const response = await fetch('/cart?view=inventory');
    const inventory = await response.json();

    // Step 2: Check if location is set and process variants
    if (!inventory.location_not_set) {
        const updates = {};
        for (const [variantId, data] of Object.entries(inventory)) {
            // Ensure both keys exist and are numbers
            const quantity = Number(data.quantity);
            const available = Number(data.available_inventory);
            if (!isNaN(quantity) && !isNaN(available) && available < quantity) {
                updates[variantId] = available; // Remove this variant from cart
            }
        }

        // Step 3: Remove variants if needed
        if (Object.keys(updates).length > 0) {
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates })
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error('Failed to update cart');
                }
            }).then(cart => {
                fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((response) => response.text())
                .then((responseText) => {
                    if(window.location.pathname.includes('/cart')) {
                        window.location.reload();
                    } else {
                        const html = new DOMParser().parseFromString(responseText, 'text/html');
                        const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                        for (const selector of selectors) {
                            const targetElement = document.querySelector(selector);
                            const sourceElement = html.querySelector(selector);
                            if (targetElement && sourceElement) {
                            targetElement.replaceWith(sourceElement);
                            }
                            if(selector === 'cart-drawer-items') {
                                document.querySelector('.cart-count-bubble span:first-child').textContent = sourceElement.dataset.cartCount || '0';
                                document.querySelector('.cart-count-bubble span:last-child').textContent = (sourceElement.dataset.cartCount || '0') + ' item' + (sourceElement.dataset.cartCount !== '1' ? 's' : '');
                            }
                            if(selector === '.cart-drawer__footer') {
                                
                                document.querySelector('.header__cart-total__price').textContent = sourceElement.querySelector('.totals__subtotal-value').textContent;
                            }
                        }
                    }
                })
                .catch((e) => {
                console.error(e);
                });
            }).catch(error => {
                console.error('Error updating cart:', error);
            });
        }
    }
}

updateCartPerInventory();

document.addEventListener('locationUpdated', async function(e) {
    const locationId = e.detail._location_id;
    setLocation(locationId);
    updateButtonsEverywhere(locationId);
});

function updateButtonsEverywhere(locationId = null, updatedQuantityInCart = null) {
    var shippingLocationId = document.body.dataset.shippingLocationId;
    var shippingLocationInventoryIds = document.body.dataset.shippingLocationInventoryIds;
    document.querySelectorAll('.cart-submit-button.inventory-tracked:not(.product-form__submit):not([data-not-available-anywhere])').forEach(quickAddButton => {
        if(updatedQuantityInCart !== null) {
            var variant_to_update = updatedQuantityInCart.variant_id;
            var new_cart_qty = updatedQuantityInCart.quantity_in_cart;
            var button_variant_id = quickAddButton.parentElement.querySelector('[name="id"]').value;
            if(button_variant_id && parseInt(button_variant_id) === parseInt(variant_to_update)) {
                quickAddButton.dataset.quantityInCart = new_cart_qty;
            }
        }
        if(locationId) {
            locationId = parseInt(locationId);
            if(quickAddButton.dataset.inventory) {
                var buttonInventory = JSON.parse(quickAddButton.dataset.inventory);
                var quantityInCart = quickAddButton.dataset.quantityInCart ? parseInt(quickAddButton.dataset.quantityInCart) : 0;
                if(shippingLocationId && shippingLocationInventoryIds && parseInt(locationId) == parseInt(shippingLocationId)) {
                    var location_inventory = 0;
                    var shipping_location_ids = shippingLocationInventoryIds.split(',');
                    shipping_location_ids.forEach(shipping_location_id => {
                        var shipping_location_inventory = parseInt(buttonInventory[shipping_location_id]);
                        location_inventory += shipping_location_inventory
                    })

                    if(location_inventory > 0 && location_inventory > quantityInCart) {
                        quickAddButton.removeAttribute('disabled');
                        quickAddButton.querySelector('span').innerText = "Add to Cart";
                    } else {
                        quickAddButton.setAttribute('disabled', true);
                        quickAddButton.querySelector('span').innerText = "Location Out of Stock";
                    }

                } else {
                    if(buttonInventory[locationId] > 0 && buttonInventory[locationId] > quantityInCart) {
                        quickAddButton.removeAttribute('disabled');
                        quickAddButton.querySelector('span').innerText = "Add to Cart";
                    } else {
                        quickAddButton.setAttribute('disabled', true);
                        quickAddButton.querySelector('span').innerText = "Location Out of Stock";
                    }
                }
                
            }
        }
        
    })
}

// if no location
window.addEventListener('DOMContentLoaded', () => {
    deferLocationPickerComponent(function() {
        if(localStorage.getItem('_location_id') === null) {
            if(localStorage.getItem('pickup-location') === null) {
                if(document.body.dataset.currentLocationId) {
                    deferShippingHandler(function() {
                        document.addEventListener('pickupLocationsLoaded', function() {
                            const storeButton = document.querySelector(`.js-store-point[data-id="${document.body.dataset.currentLocationId}"] .js-select-store-button`);
                            if(storeButton) {
                                storeButton.click();
                            }
                        })
                    })
                } else {
                    deferShippingHandler(function() {
                        if(document.querySelectorAll('location-picker').length) {
                            document.querySelectorAll('location-picker')[0].click();
                        }
                    })
                }
                
            } else {
                let selectedLocation = localStorage.getItem('pickup-location');
                selectedLocation = JSON.parse(selectedLocation);
                localStorage.setItem('_location_id', parseInt(selectedLocation.id));
            }
        } else {
            if(!document.body.dataset.currentLocationId) {
                setLocation(localStorage.getItem('_location_id'));
            }
        }
    })
})


document.addEventListener('afterUpdateQuantity', (event) => {
    if(event.detail.cartData.items_added) {
        for (const item of event.detail.cartData.items_added) {
            if(item.variant_id) {
                const matchedEntry = event.detail.cartData.items.find(entry => parseInt(entry.id) === parseInt(item.variant_id));
                
                if(matchedEntry) {
                    if(localStorage.getItem('_location_id')) {
                        updateButtonsEverywhere(localStorage.getItem('_location_id'), { 
                            variant_id: matchedEntry.id,
                            quantity_in_cart: matchedEntry.quantity
                        });
                    } else {
                        updateButtonsEverywhere(null, { 
                            variant_id: matchedEntry.id,
                            quantity_in_cart: matchedEntry.quantity
                        });
                    }
                }
                
            }
        }
    }
    if(event.detail.cartData.items_removed.length > 0) {
        for (const item of event.detail.cartData.items_removed) {
            if(item.variant_id) {
                if(localStorage.getItem('_location_id')) {
                    updateButtonsEverywhere(localStorage.getItem('_location_id'), { 
                        variant_id: parseInt(item.variant_id),
                        quantity_in_cart: 0
                    });
                } else {
                    updateButtonsEverywhere(null, { 
                        variant_id: parseInt(item.variant_id),
                        quantity_in_cart: 0
                    });
                }
            }
        }
    }
});

document.addEventListener('afterCartChanged', (event) => {
    if(event.detail.cartData.id) {
        if(localStorage.getItem('_location_id')) {
            updateButtonsEverywhere(localStorage.getItem('_location_id'), { 
                variant_id: event.detail.cartData.id,
                quantity_in_cart: event.detail.cartData.quantity
            });
        } else {
            updateButtonsEverywhere(null, { 
                variant_id: event.detail.cartData.id,
                quantity_in_cart: event.detail.cartData.quantity
            });
        }
       
    }
});